import { Team } from 'entities';

import { Link, Skeleton } from 'components/Blocks';

interface TeamCardsProps {
  teams: Team[];
  loading?: boolean;
}

const loadEntries = [...new Array(8)];

export function TeamCards({ teams, loading }: TeamCardsProps) {
  return (
    <div className="grid grid-cols-4 gap-4 phone:grid-cols-1">
      {loading ? (
        <>
          {loadEntries.map((_, index) => (
            <Skeleton key={`load-area-${index}`} height={150} />
          ))}
        </>
      ) : (
        <>
          {teams.map(({ name, id }) => (
            <Link
              className="grid h-[150px] shrink-0 place-content-center rounded-md border text-xl text-primary-dark shadow-sm transition-colors hover:bg-hover phone:h-24"
              key={id}
              to="teamProfile"
              params={{ teamId: id }}
            >
              {name}
            </Link>
          ))}
        </>
      )}
    </div>
  );
}
